import styled from "@emotion/styled";
import { Card, Typography } from "@mui/material";

export const DashboardCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

export const SmallLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 600,
  letterSpacing: 0.2,
}));
